import React from "react";

import Dashboard from "../components/Dashboard";

function DashboardPage(props) {
  return <Dashboard data={props.props} />;
}

export default DashboardPage;
